import { useState } from "react";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import DetailsTable from "../DetailsTable/DetailsTable.js";
import { getTranslatedText as translate } from "../../Localization/Translation";

const DoneOrders = () => {
  const { locale, MyOrders, setSelectedOrderIndex, MyOrdersStatusesAndText } =
    useBetween(useSelector((state) => state.useSharedState));
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (orderIndex) => {
    setSelectedOrderIndex(orderIndex);
    setShow(true);
  };

  const DoneOrders = MyOrders;

  let d = "-1";
  var MyOrderCards = DoneOrders.map((Order, index) => {
    d = Number(d) + 1;
    return (
      <div
        className={
          "my-orders-item-list col-md-3 col-sm-12 animate__animated animate__fadeInLeft animate__delay-" +
          d +
          "s"
        }
        key={Order.id}
      >
        <div className="card text-center my-orders-card-box">
          <div className="card-header my-orders-card-header">
            <span className="orders-label-card">
              {translate("order-num-notification", locale)}
            </span>
            {Order.orderNumber}
          </div>
          <div className="card-body">
            <p className="card-text">
              <span className="orders-label-card">
                {translate("Laundry-name-label-order", locale)}
              </span>
              {Order.LaundryName}
            </p>
            <Button
              onClick={() => handleShow(index)} //connect with api
              className="btn btn-primary my-orders-card-btn"
            >
              {translate("details-name-btn-order", locale)}
            </Button>
          </div>
        </div>
      </div>
    );
  });

  return (
    <div className="my-orders-component">
      <div className="my-orders-list-all row" dir="auto">
        {MyOrderCards}
      </div>

      <Modal show={show} onHide={handleClose} size="md" dir="auto">
        <Modal.Header>
          <span className="orders-label-card">
            {translate("details-name-btn-order", locale)}
          </span>
        </Modal.Header>
        <Modal.Body>
          <DetailsTable done={true} />
        </Modal.Body>
        <Modal.Footer dir="auto">
          <Button
            variant="primary"
            className="btn btn-calendar-modal-save"
            onClick={handleClose}
          >
            {translate("modal-ok-btn", locale)}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DoneOrders;
